var map = {
  "./assets/favicons-prod/android-chrome-192x192.png": "193639",
  "./assets/favicons-prod/android-chrome-512x512.png": "724127",
  "./assets/favicons-prod/apple-touch-icon.png": "75856",
  "./assets/favicons-prod/browserconfig.xml": "46126",
  "./assets/favicons-prod/favicon-16x16.png": "560719",
  "./assets/favicons-prod/favicon-32x32.png": "378439",
  "./assets/favicons-prod/favicon-alert-16x16.png": "213282",
  "./assets/favicons-prod/favicon-alert-32x32.png": "503894",
  "./assets/favicons-prod/favicon-alert.ico": "316293",
  "./assets/favicons-prod/favicon.ico": "165560",
  "./assets/favicons-prod/mstile-150x150.png": "142699",
  "./assets/favicons-prod/site.webmanifest": "568101",
  "./assets/favicons-prod/upc-favicon.ico": "675221"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = () => (Object.keys(map));
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 167802;
